/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { SET_COMMENTS, UPDATE_COMMENT } from './actions';
import {
  SET_BLOCK_FEED_DATA,
  APPEND_BLOCK_FEED_DATA,
  PREPEND_BLOCK_FEED_DATA,
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
  BLOCK_FEED_DATA_LOAD_MORE_SUCCESS,
  BLOCK_FEED_DATA_FETCH_SUCCESS,
} from '../Feeds/actions';
import { GET_LINKED_NOTIFICATION_DATA } from '../LinkedNotification/actions';
import { ActionTypes } from '../Posts/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';

const INITIAL_STATE = Immutable.fromJS({
  byId: {},
});

export function Comments(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_COMMENT: {
      const { commentId, changes } = action;
      const comment = state
        .getIn(['byId', commentId])
        .merge(Immutable.fromJS(changes));
      return state.setIn(['byId', commentId], comment);
    }
    case APPEND_BLOCK_FEED_DATA:
    case PREPEND_BLOCK_FEED_DATA:
    case SET_COMMENTS:
    case SET_BLOCK_FEED_DATA:
    case GET_LINKED_NOTIFICATION_DATA:
    case FEED_DATA_FETCH_SUCCESS:
    case BLOCK_FEED_DATA_FETCH_SUCCESS:
    case FEED_DATA_REFRESH_SUCCESS:
    case FEED_DATA_LOAD_MORE_SUCCESS:
    case BLOCK_FEED_DATA_LOAD_MORE_SUCCESS: {
      const comments = Immutable.fromJS(action.comments);
      let updatedState = state;
      for (const comment of comments.values()) {
        updatedState = updatedState.setIn(['byId', comment.get('id')], comment);
      }
      return updatedState;
    }
    case ActionTypes.POST_REMOVED: {
      const { postId } = action;
      let updatedState = state;

      updatedState = updatedState.filter((comment) => {
        return comment.get('document') !== postId;
      });
      return updatedState;
    }
    case LOGOUT_SUCCESS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
